import { ReactComponent as HandleIcon } from './vertical-hamburger.svg';

export default HandleIcon;
